exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n    position: absolute;\n    left: calc(50% - 25px);\n    top: 85px;\n    width: 50px;\n    height: 50px;\n}\n\n.loader img {\n\twidth: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/src/app/loader/loader.component.css
// module id = ../../../../../src/app/loader/loader.component.css
// module chunks = 1